import { MaterialIcon } from "@website/icons/material";
import { MiniChips, MiniChipsColorType } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveCommentRatingPropertiesType } from "@website/widget/reserve-comment/reserve-comment-rating/reserve-comment-rating.types";
import { useRouter } from "next/router";
export const ReserveCommentRating = (properties: ReserveCommentRatingPropertiesType) => {
  const router = useRouter();
  const {
    rate,
    size = "medium"
  } = properties;
  const color = (rate_0: number) => {
    switch (true) {
      case rate_0 < 2:
        {
          return "error";
        }
      case rate_0 >= 2 && rate_0 < 3:
        {
          return "inverse-warning";
        }
      case rate_0 >= 3 && rate_0 < 4:
        {
          return "default";
        }
      default:
        {
          return "success";
        }
    }
  };
  return <MiniChips StartIcon={<MaterialIcon className="text-base" name="stars" />} color={color(rate) as MiniChipsColorType} size={size} text={numberConvert(rate, {
    locale: router.locale
  })} variant="accent" />;
};